/* eslint-disable import/no-anonymous-default-export */

import { docodeHexResponse } from "../../../_common/common.utils";
import SaleDetailsActionTypes from "./saleDetails.types";

const INITIAL_STATE = {
  fetchSaleDetailsResponse: null,
  fetchSaleDetailsArr: [],
  createSaleDetailsResponse: null,
  updateSaleDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    /** ***************** FETCH SALE DETAILS START *********************** */
    case SaleDetailsActionTypes.FETCH_SALE_DETAILS_SUCCESS:
      return {
        ...state,
        fetchSaleDetailsResponse: action.payload,
        fetchSaleDetailsArr: docodeHexResponse(action.payload, "FetchSaleKey"),
      };

    case SaleDetailsActionTypes.FETCH_SALE_DETAILS_FAILURE:
      return {
        ...state,
        fetchSaleDetailsResponse: action.payload,
        fetchSaleDetailsArr: [],
      };

    case SaleDetailsActionTypes.FETCH_SALE_DETAILS_CHANGED:
      return {
        ...state,
        fetchSaleDetailsResponse: null,
        fetchSaleDetailsArr: [],
      };
    /** ***************** FETCH SALE DETAILS END *********************** */

    /** ***************** CREATE SALE DETAILS START *********************** */
    case SaleDetailsActionTypes.CREATE_SALE_SUCCESS:
      return { ...state, createSaleDetailsResponse: action.payload };

    case SaleDetailsActionTypes.CREATE_SALE_FAILURE:
      return { ...state, createSaleDetailsResponse: action.payload };

    case SaleDetailsActionTypes.CREATE_SALE_CHANGED:
      return { ...state, createSaleDetailsResponse: null };
    /** ***************** CREATE SALE DETAILS END *********************** */

    /** ***************** UPDATE SALE DETAILS START *********************** */
    case SaleDetailsActionTypes.UPDATE_SALE_SUCCESS:
      return { ...state, updateSaleDetailsResponse: action.payload };

    case SaleDetailsActionTypes.UPDATE_SALE_FAILURE:
      return { ...state, updateSaleDetailsResponse: action.payload };

    case SaleDetailsActionTypes.UPDATE_SALE_CHANGED:
      return { ...state, updateSaleDetailsResponse: null };
    /** ***************** UPDATE SALE DETAILS END *********************** */

    default:
      return state;
  }
};
